import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import AddEditFormCst from "@components/AddEditFormCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { useFetchDetail, usePutDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import AnimationFadeIn from "@components/AnimationFadeIn";

const EditCategory: React.FC = () => {
  const { t } = useTranslation(["categories-page"]);
  const { id, idInitiative, idCategory } = useParams();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const { columns, dataDetail, mutate } = useFetchDetail(
    ServicesURL.categories + `/${idInitiative}/categories`,
    idCategory || "",
    PagesID["corporate.initiative.categories"],
  );

  const { trigger: triggerCategory, setId: setCategoryId } = usePutDetail(
    ServicesURL.categories + `/${idInitiative}/categories`,
  );
  const navigate = useNavigate();

  useEffect(() => {
    idCategory && setCategoryId(idCategory);
  }, [idCategory]);

  const onSubmit = async (inputForm: any) => {
    const objToSend: any = {
      name: inputForm["name"]?.trimStart().trimEnd() || "",
      order: +inputForm["order"] || undefined,
      premium: inputForm["premium"] || false,
    };

    try {
      await triggerCategory(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
    mutate && mutate(inputForm);
    // navigate(`/corporate/${id}/detail/initiative/${idInitiative}/categories`);
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corp-initiatives.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              row={dataDetail}
              columns={columns}
              onSubmit={onSubmit}
              idEntity={idCategory}
              backButton={() => {
                navigate(
                  `/corporate/${id}/detail/initiative/${idInitiative}/categories`,
                );
              }}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("outcome-item", { ns: "modal" })}
        description={t("outcome-item", { ns: "modal" })}
        onCallBackClosed={() => {
          navigate(
            `/corporate/${id}/detail/initiative/${idInitiative}/categories`,
          );
        }}
        onActionConfirmed={() => {
          navigate(
            `/corporate/${id}/detail/initiative/${idInitiative}/categories`,
          );
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default EditCategory;
